import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface WarehouseOption {
  warehouseId: string;
  warehouseName: string;
}

interface ApiResponse {
  warehouses: WarehouseOption[];
  shipmentPoints: NewWarehouseOption[];
}

interface NewWarehouseOption {
  shipmentPointName: string;
  shipmentPointId: string;
  shipmentPointNameArabic: string;
}

interface ProductParams {
  warehouseId: any;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

// const getUserInfo = () => {
//   const token = Cookies.get("token");

//   if (!token) {
//     throw new Error("Authorization token not found");
//   }

//   return jwtDecode<DecodedToken>(token);
// };

const getShipmentDropdown = async (params: any): Promise<ApiResponse> => {
  //   const user_info = getUserInfo();
  const response = await axios.get<ApiResponse>(`/nwc/warehouse`, {
    headers: getHeader(),
    params: params,
  });
  return response.data;
};

export const getNewShipmentDropdown = async (
  params: any
): Promise<ApiResponse> => {
  //   const user_info = getUserInfo();
  const response = await axios.get<ApiResponse>(`/nwc/shipmentpoints`, {
    headers: getHeader(),
    params: params,
  });
  return response.data;
};

export const getAvailableProducts = async (
  ProductParams: any
): Promise<ApiResponse> => {
  //   const user_info = getUserInfo();
  const { warehouseId } = ProductParams;
  const response = await axios.get<ApiResponse>(
    `/nwc/products/${warehouseId}`,
    {
      headers: getHeader(),
      params: ProductParams,
    }
  );
  return response.data;
};

export const getAddressDropdown = async (params: any): Promise<any> => {
  // const user_info = getUserInfo();
  params.page_size = 40;
  var ok = params;
  params = { ...params, ...ok };
  const response = await axios.post<any>(
    `/nwc/addresses/?page_number=1&page_size=50`,
    params,
    {
      headers: getHeader(),
    }
  );
  return response.data;
};

export const createOrder = async (data: any): Promise<any> => {
  const response = await axios.post<any>(`/nwc/order`, data, {
    headers: getHeader(),
  });
  return response.data;
};

export const confirmOrder = async (
  order_id: any,
  address_id: any,
  delivery_by: any
): Promise<any> => {
  const response = await axios.put<any>(
    `/nwc/order/confirm/${order_id}/${address_id}`,
    { params: { delivery_by } },
    {
      headers: getHeader(),
    }
  );
  return response.data;
};

export const productList = async (
  id: any,
  dType: any,
  outletID: any
): Promise<any> => {
  const dTypetemp = dType === "1" ? "BERAIN" : "NWC";
  const response = await axios.get<any>(
    `nwc/inventory?warehouseId=${id}&delivery_by=${dTypetemp}&outlet_id=${outletID}`,
    {
      headers: getHeader(),
    }
  );
  return response.data;
};

export const handleEditedOrder = async (payload: any) => {
  const response = await axios.put<any>(`nwc/update/order`, payload, {
    headers: getHeader(),
  });
  return response;
};

export const deleteProduct = async (payload: any) => {
  const response = await axios.put<any>(`nwc/cancel/order/item`, payload, {
    headers: getHeader(),
  });
  return response;
};

export const deleteFullProduct = async (id: number, cancel_reason: string | null): Promise<any> => {
  let url = `/nwc/delete/order/${id}`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
    data: { cancel_reason },
  });
  return response.data;
};

export default getShipmentDropdown;
